import React from 'react'
import Page from '../Page'

const IC = ({ testResult }) => {
  return (
    <>
      <Page
        testResult={testResult}
        title="معرفی الگوی رفتاری IC تاثیرگذاری + قانون‌گرایی"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری  IC ترکیبی از ویژگی‌های تاثیرگذاری I و وظیفه‌گرایی و دقت بالا C  هستند. این یعنی درون این افراد همزمان یک انرژی اجتماعی و شاد، و یک میل شدید به نظم و دقت وجود دارد. آن‌ها به‌دنبال اثرگذاری مثبت روی دیگران هستند، اما این کار را بر اساس چارچوب، استاندارد، و شایستگی انجام می‌دهند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="چکیده شخصیت افراد IC :"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>اجتماعی هستند اما در چارچوب.</li>
          <li>اهل گفتگو هستند اما ساختارمند.</li>
          <li>مشتاق دیده‌شدن هستند اما از مسیر درست.</li>
          <li>دوست دارند تاثیرگذار باشند، اما نه با هیاهو، بلکه با استدلال و منطق.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="رفتار عمومی آن‌ها چگونه است؟"
      >
        <p className="text-gray-800 leading-7">
          افراد  IC معمولاً بسیار سنجیده رفتار می‌کنند. در جمع، دوستانه و خوش‌صحبت هستند اما مرزهای حرفه‌ای خود را حفظ می‌کنند. ممکن است در نگاه اول گرم و شوخ‌طبع به نظر برسند، اما پشت این ظاهر، فردی تحلیل‌گر و قانون‌مدار نشسته که از روی نظم و دلیل تصمیم می‌گیرد.
        </p>
        <p className="text-gray-800 leading-7">
          مثال واقعی از رفتار  IC :
          فرض کنید فردی با الگوی  IC مدیر یک بخش است. او در جلسه تیمی با انرژی شروع می‌کند، برای همه انگیزه ایجاد می‌کند و با شوخ‌طبعی فضا را صمیمی می‌سازد. اما به‌محض ورود به فاز تصمیم‌گیری، لحنش تغییر می‌کند: منظم، دقیق و مستند صحبت می‌کند. همه را به مشارکت دعوت می‌کند ولی اجازه نمی‌دهد از اصول و فرآیندها عدول شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="معرفی فیلم :"
      >
        <p className="text-gray-800 leading-7">
          Moneyball   2011 این فیلم با نقش‌آفرینی برد پیت، نمونه‌ای عالی از شخصیتی  IC است: یک مدیر کاریزماتیک که از طریق داده‌ها، تحلیل دقیق و در عین حال با مهارت‌های ارتباطی فوق‌العاده، تحول ایجاد می‌کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نقاط قوت افراد IC :"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>برنامه‌ریز و هدفمند</li>
          <li>تاثیرگذار و قابل اعتماد</li>
          <li>تحلیل‌گر دقیق همراه با فن بیان قوی</li>
          <li>متعهد به کیفیت و پیگیری</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="چالش‌های افراد IC :"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>تمایل به تاییدطلبی</li>
          <li>وسواس در جزئیات</li>
          <li>تردید در تصمیم‌گیری‌های سریع</li>
          <li>نیاز به کنترل نتیجه نهایی</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="جمع‌بندی معرفی:"
      >
        <p className="text-gray-800 leading-7">
          الگوی  IC، نمایانگر شخصیت‌هایی است که می‌توانند هم تاثیرگذار باشند، هم قابل اتکا. آن‌ها سخنوران باهوشی‌اند که کار را با فکر و تحلیل پیش می‌برند، اما برای موفقیت بیشتر، لازم است بر کمال‌گرایی و تردید خود غلبه کرده و گاهی در لحظه تصمیم‌گیری کنند، نه بعد از چند روز بررسی!
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ابعاد و توصیف ویژگی‌های رفتاری الگوی IC"
      >
        <p className="text-gray-800 leading-7">
          الگوی رفتاری  IC ترکیبی از دو بعد  تاثیرگذاری اجتماعی   I و  وظیفه‌گرایی دقیق   C   است. این افراد معمولاً تعادلی جالب بین رفتارهای گرم و برون‌گرا، با ذهنی دقیق و ساختارمند دارند. در این بخش، ابعاد شخصیتی آن‌ها را دقیق‌تر بررسی می‌کنیم:
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. تاثیرگذاری همراه با دقت</h3>
        <p className="text-gray-800 leading-7">
          این افراد با فن بیان، شوخ‌طبعی و ارتباط مؤثر بر دیگران تاثیر می‌گذارند،
          اما در عین حال سعی می‌کنند این تأثیرگذاری در چارچوب منطق، اصول و استانداردها باشد.
          برخلاف تیپ I  خالص که گاهی بی‌برنامه جلو می‌رود،  ICها علاقه دارند تأثیرشان قابل اندازه‌گیری و دقیق باشد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. احترام به ساختار، همراه با تعامل بالا</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها برای نظم، استاندارد و برنامه ارزش قائل‌اند،
          ولی در عین حال می‌توانند با گروه، همکاران یا مشتریان ارتباط انسانی گرم و سازنده برقرار کنند.
          جذاب و متین هستند؛ نه خیلی خشک، نه خیلی بی‌قید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. قدرت در سخن گفتن + تمایل به اثبات منطقی</h3>
        <p className="text-gray-800 leading-7">
          در صحبت‌کردن مهارت دارند، اما وقتی بحث تخصصی می‌شود،
          به تحلیل و مستندسازی تکیه می‌کنند. یعنی نه صرفاً حرف می‌زنند، نه صرفاً تحلیل می‌کنند—ترکیبی از هر دو.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تمایل به اثربخشی + نگرانی از اشتباه</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها می‌خواهند دیگران را تحت تأثیر قرار دهند و دیده شوند،
          اما از قضاوت اشتباه می‌ترسند. در نتیجه گاهی پیش از اقدام زیاد تحلیل می‌کنند یا از نتیجه نهایی مطمئن نمی‌شوند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. نیاز به تأیید اجتماعی + تمایل به کنترل جزئیات</h3>
        <p className="text-gray-800 leading-7">
          این افراد به تأیید دیگران اهمیت می‌دهند  ویژگی I  ،
          ولی این تأیید باید ناشی از عملکرد دقیق و درست آن‌ها باشد  ویژگی C  .
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ابعاد و توصیف ویژگی‌های رفتاری الگوی IC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. رفتار بیرونی دوستانه، درونگرایی نسبی در تصمیم‌گیری</h3>
        <p className="text-gray-800 leading-7">
          گرچه در ظاهر اجتماعی و راحت‌اند،
          اما درون‌شان تمایل دارند بررسی کنند، تحلیل کنند، و بدون هیجان تصمیم بگیرند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. در محیط کاری:</h3>
        <p className="text-gray-800 leading-7">
          ایده‌آل برای موقعیت‌هایی که نیاز به ارائه، تحلیل، نگارش، مذاکره علمی، یا گزارش‌دهی دقیق دارند.
          همچنین در آموزش، تدوین محتوا، یا سخنرانی تخصصی بسیار موفق‌اند.
        </p>
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          تصور کنید یک  IC مسئول آموزش کارکنان است. او نه‌تنها با انرژی و لبخند کلاس را برگزار می‌کند، بلکه مطالب را کاملاً با استاندارد، زمان‌بندی و جزئیات ارائه می‌دهد. دانشجویان هم از جذابیت او لذت می‌برند و هم به اطلاعات دقیقش اعتماد می‌کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="تشریح الگوی رفتاری IC"
      >
        <p className="text-gray-800 leading-7">
          الگوی رفتاری  IC ترکیبی است از دو نیروی ظاهراً متضاد اما مکمل:
          نفوذ اجتماعی  و  کنترل تحلیلی .
          این افراد با شخصیت متین، باهوش، قابل اتکا و ارتباط‌گر خود، معمولاً در سازمان‌ها و محیط‌های تیمی به عنوان  مغز متفکر دوست‌داشتنی  شناخته می‌شوند!
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. سبک رفتاری روزمره</h3>
        <p className="text-gray-800 leading-7">
          افراد  IC معمولاً در ظاهر:
          خوش‌صحبت و باانرژی  ،
          درون‌گرا در تصمیم‌گیری  ،
          و  کاملاً ساختارمند در عمل هستند.
          آن‌ها سعی می‌کنند روابط مثبت با دیگران ایجاد کنند، اما با حفظ مرزها و دقت بالا. بی‌نظمی، اشتباهات تکراری و افراد پرهیاهو اما بی‌برنامه برای آن‌ها آزاردهنده است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. سبک عملکرد در کار و سازمان</h3>
        <p className="text-gray-800 leading-7">
          عاشق جزئیاتند ولی نمی‌خواهند خشک و سرد به نظر برسند؛ پس در جلسات با تأثیرگذاری کلامی و انرژی مثبت  ، داده‌های دقیق را به شکلی جذاب منتقل می‌کنند.
          از آن‌دسته افرادی‌اند که می‌توانند  یک گزارش را هم قانع‌کننده بنویسند و هم زیبا طراحی کنند.
          تصمیم‌هایشان معمولاً با تأخیر اندکی همراه است چون می‌خواهند مطمئن شوند که اطلاعات کافی دارند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="تشریح الگوی رفتاری IC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. واکنش در شرایط فشار</h3>
        <p className="text-gray-800 leading-7">
          در موقعیت‌های پرتنش، به جای واکنش احساسی، سعی می‌کنند کنترل را حفظ کرده و با تحلیل جلو بروند.
          ممکن است در برابر انتقاد زیاد، دفاعی یا تردیدآمیز شوند، چون دروناً نگران "خوب نبودن" هستند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. در نقش رهبری یا تاثیرگذاری</h3>
        <p className="text-gray-800 leading-7">
          رهبرانی خوش‌رو، دقیق و نتیجه‌محورند.
          در مدیریت جلسات، هم شنونده خوبی هستند هم مدیر خوب بحث.
          اما گاهی نیاز به تصمیم‌گیری سریع یا قاطعیت ناگهانی دارند که برایشان چالش‌برانگیز است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. در ارتباطات بین‌فردی</h3>
        <p className="text-gray-800 leading-7">
          در ابتدا کمی محافظه‌کارانه رفتار می‌کنند.
          پس از اعتمادسازی، بسیار صمیمی، گرم و حمایت‌گر می‌شوند.
          از گفتگوهای سطحی خوششان نمی‌آید و دوست دارند روابط معنادار و ماندگار داشته باشند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. ریسک‌پذیری و تغییر</h3>
        <p className="text-gray-800 leading-7">
          تغییر را در صورتی می‌پذیرند که منطقی و مستند باشد.
          علاقه‌ای به ریسک بی‌حساب ندارند، اما اگر چارچوب منطقی وجود داشته باشد، از نوآوری استقبال می‌کنند.
        </p>
        <p className="text-gray-800 leading-7">
          مثال کاربردی
          فرض کنید فردی با الگوی  IC قرار است سمیناری برگزار کند. او نه‌تنها محتوا را با دقت و کیفیت بالا آماده می‌کند، بلکه با تسلط کلامی و طنز ملایم، ارتباطی عالی با مخاطبان برقرار می‌کند. حواسش هست که زمان‌بندی رعایت شود، اسلایدها حرفه‌ای باشد و همه چیز در استاندارد کامل پیش برود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="انگیزه‌های رفتاری افراد با الگوی IC"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری  IC، برای انگیزش و حفظ بهره‌وری، به ترکیبی از تحسین اجتماعی، فرصت برای اثربخشی، و حفظ چارچوب و کیفیت نیاز دارند. آن‌ها به دنبال تأثیرگذاری معنادار هستند، اما نه به هر قیمتی. برایشان مهم است که دیده شوند، اما از مسیر درست و حرفه‌ای.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. دیده‌شدن همراه با شایستگی</h3>
        <p className="text-gray-800 leading-7">
          ICها وقتی حس کنند که به خاطر توانمندی، دقت یا تاثیر مثبت‌شان شناخته شده‌اند  ، انگیزه می‌گیرند.
          تأیید دیگران برایشان مهم است، اما باید با کار درست و خروجی باکیفیت همراه باشد.
          مثال: وقتی در جلسه‌ای سخنرانی کنند و بعداً شنوند:
          چه‌قدر دقیق حرف زدی! هم جذاب بود، هم مستند  – این جمله برایشان محرکی فوق‌العاده قوی است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. نیاز به نظم در کنار انعطاف نسبی</h3>
        <p className="text-gray-800 leading-7">
          دوست دارند کارها بر اساس برنامه پیش برود، اما نه آن‌قدر خشک که نتوانند خلاقیت به خرج دهند.
          اگر در پروژه‌ای احساس کنند که کنترل، وضوح و معیار سنجش وجود ندارد، دلسرد می‌شوند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. فرصت ابراز و ارائه</h3>
        <p className="text-gray-800 leading-7">
          ارائه ایده، سخنرانی، نوشتن یک گزارش یا تدریس تخصصی برایشان لذت‌بخش است، چون هم دیده می‌شوند و هم می‌توانند توان تحلیل خود را نشان دهند.
          اگر فقط در پشت صحنه باشند، به‌مرور دچار فرسودگی عاطفی و کاهلی خواهند شد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. بازخورد منصفانه و محترمانه</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها از بازخورد سازنده استقبال می‌کنند، اما باید محترمانه، دقیق و با پیشنهاد راه‌حل باشد.
          از تحقیر یا قضاوت شتاب‌زده، رنج می‌برند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. تعلق به تیم‌های محترم و حرفه‌ای</h3>
        <p className="text-gray-800 leading-7">
          کار کردن با افرادی که هم با ادب‌اند و هم دقیق، به آن‌ها انگیزه می‌دهد.
          از کار با افراد شلخته، سطحی یا پرحاشیه خسته می‌شوند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="انگیزه‌های رفتاری افراد با الگوی IC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. آزادی در چارچوب</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها نه آزادی مطلق می‌خواهند  مثل تیپ High I
          و نه چارچوب مطلق  مثل High C  .
          بلکه ترکیبی از آزادی بیان و رعایت استانداردها برایشان ایده‌آل است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          The King's Speech  2010
          شخصیت اصلی فیلم، کسی است که هم دقت و کمال‌گرایی دارد و هم نیاز به دیده‌شدن. داستان رشد او از اضطراب تا اقتدار، الگوی زیبایی برای شخصیت  IC ارائه می‌دهد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری افراد با الگوی IC"
      >
        <p className="text-gray-800 leading-7">
          تیپ رفتاری  IC در محیط کاری، الگویی از ساختار + صمیمیت، دقت + خلاقیت، و ارتباط + تحلیل ارائه می‌دهد. این افراد در کارشان منظم، دقیق و محتاط‌اند، اما در عین حال توانایی بالایی در ارتباطات انسانی، انتقال پیام و انگیزش دیگران دارند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. برنامه‌ریزی ساختاریافته همراه با انعطاف منطقی</h3>
        <p className="text-gray-800 leading-7">
          ICها برای انجام کار مؤثر، به برنامه‌ریزی دقیق نیاز دارند، ولی اجازه می‌دهند اگر منطق ایجاب کند، مسیر را اصلاح کنند.
          آن‌ها کارها را در ذهن خود تقسیم‌بندی می‌کنند و برای هر بخش، زمان، قالب و هدف تعریف می‌کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. پایبند به استانداردهای کیفیت</h3>
        <p className="text-gray-800 leading-7">
          اگر قرار است گزارشی تهیه کنند، آن را کامل، مستند و قابل استناد آماده می‌کنند.
          برای آن‌ها "خوب" کافی نیست، باید "درست و دقیق" باشد.
          مثال: طراحی یک بروشور تبلیغاتی توسط  IC، هم از نظر محتوایی دقیق است و هم از نظر گرافیکی چشم‌نواز. چون زیبایی و صحت برایشان مکمل هم‌اند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. پرهیز از کار شتاب‌زده یا بدون اطلاعات کافی</h3>
        <p className="text-gray-800 leading-7">
          ICها دوست ندارند کاری را با حدس و گمان جلو ببرند.
          "اول اطلاعات، بعد اقدام" شعار ذهنی‌شان است.
          اگر مدیری از آن‌ها انتظار تصمیم‌گیری لحظه‌ای داشته باشد، دچار اضطراب و شک می‌شوند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. حساس به بازخورد و نگاه دیگران</h3>
        <p className="text-gray-800 leading-7">
          دروناً به تأیید همکاران و مدیران اهمیت می‌دهند. اگر مورد بی‌توجهی یا انتقاد ناعادلانه قرار گیرند، انگیزه‌شان افت می‌کند.
          بر اساس واکنش دیگران، کیفیت کار خود را بازنگری می‌کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. تمایل به کار مستقل، در عین حفظ ارتباطات تیمی</h3>
        <p className="text-gray-800 leading-7">
          ICها به محیط‌های آرام و بدون تنش علاقه دارند.
          اغلب ترجیح می‌دهند بخشی از پروژه را خودشان انجام دهند، ولی با تیم در ارتباط باشند.
          از کار گروهی پر از اختلاف یا شلوغی شدید دوری می‌کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری افراد با الگوی IC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. پیگیر و وفادار به اهداف</h3>
        <p className="text-gray-800 leading-7">
          اگر پروژه‌ای را بپذیرند، تا پایان همراه هستند.
          آن‌ها معمولاً بدون حاشیه کار را پیش می‌برند، و حتی اگر از لحاظ احساسی خسته شوند، کار را ناقص نمی‌گذارند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. مستندسازی و ثبت فرآیندها</h3>
        <p className="text-gray-800 leading-7">
          نوشتن، تحلیل، گزارش‌نویسی و تولید محتوا از عادت‌های کاری رایج آن‌هاست.
          آن‌ها دوست دارند کار خود مستند باشد تا در آینده قابل دفاع یا استفاده باشد.
        </p>
        <p className="text-gray-800 leading-7">
          پیشنهاد عملی:
          برای بالابردن بهره‌وری در  ICها، از ابزارهایی مثل:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>تقویم Google Calendar  یا Notion</li>
          <li>چک‌لیست‌های دقیق</li>
          <li>بازخوردهای سازنده و شفاف</li>
        </ul>
        <p className="text-gray-800 leading-7">
          استفاده شود. این ابزارها به ساختار ذهنی آن‌ها کمک زیادی می‌کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌های رفتاری افراد با الگوی IC"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای الگوی  IC جهان را با ترکیبی از عینیت و انسان‌گرایی، تحلیل و احساس، ساختار و صمیمیت می‌نگرند. آن‌ها نه صرفاً منطقی‌اند که از انسانیت غافل شوند، و نه صرفاً احساسی که از دقت و اصول عبور کنند. همین نگاه متعادل، آن‌ها را در تحلیل مسائل پیچیده و مدیریت روابط بین‌فردی موفق می‌سازد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. نگاه هدفمند به تعاملات</h3>
        <p className="text-gray-800 leading-7">
          ارتباط برای  IC صرفاً معاشرت نیست؛ بلکه ابزاری برای تأثیرگذاری مفید، ایجاد ارزش، و اصلاح مسیرها  ست.
          آن‌ها اغلب پشت کلمات و رفتار دیگران، الگوها، انگیزه‌ها و جزئیات دقیق‌تری را می‌بینند و تحلیل می‌کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. دیدگاه تحلیل‌گر اما نه سرد</h3>
        <p className="text-gray-800 leading-7">
          نگاه‌شان به دنیا بر پایه واقعیت است، اما با رنگ احساس.
          یعنی هنگام برخورد با مشکلات، ابتدا تحلیل می‌کنند ولی سعی دارند درک انسانی از موقعیت هم داشته باشند.
          ممکن است از دروغ، دو‌پهلو حرف زدن یا سطحی‌نگری دیگران دلگیر شوند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. باور به ارزش کار خوب و درست</h3>
        <p className="text-gray-800 leading-7">
          ICها اعتقاد دارند که کاری باید هم اثربخش باشد، هم با کیفیت، هم درست.
          برای آن‌ها نگاه "بگذره بره" یا "حالا کی متوجه میشه؟" بی‌معناست.
          حتی اگر دیگران متوجه ضعف‌ها نشوند، خودشان می‌دانند، و همین کافی‌ست که آن را اصلاح کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. دیدگاهشان درباره تغییر</h3>
        <p className="text-gray-800 leading-7">
          اگر تغییری معنادار، منطقی و با دلیل باشد، آن را می‌پذیرند.
          اما تغییرهای سریع، بدون توجیه یا احساسی، برایشان تنش‌زا و بی‌اعتمادکننده است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. درباره روابط انسانی</h3>
        <p className="text-gray-800 leading-7">
          برای آن‌ها رابطه‌ای ارزش دارد که هم احترام‌آمیز باشد و هم ریشه‌دار.
          از شوخی‌های سطحی یا ارتباطات ناپایدار دل‌زده می‌شوند.
          در عین حال، اگر ارتباطی رشد کند و با اصول همخوان باشد، به‌شدت به آن پایبند می‌مانند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌های رفتاری افراد با الگوی IC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. نسبت به خود</h3>
        <p className="text-gray-800 leading-7">
          اغلب خود را با معیار بالا قضاوت می‌کنند.
          اگر به هدف نرسند یا کار ضعیفی تحویل دهند، خودسرزنشی می‌کنند، حتی اگر دیگران راضی باشند.
        </p>
        <p className="text-gray-800 leading-7">
          مثال واقعی:
          فرد  IC هنگام گرفتن یک پروژه جدید ابتدا می‌پرسد:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>هدف چیست؟</li>
          <li>استاندارد کدام است؟</li>
          <li>مخاطب کیست؟</li>
          <li>قالب خروجی چه باید باشد؟</li>
        </ul>
        <p className="text-gray-800 leading-7">
          اما هم‌زمان سعی می‌کند با اعضای تیم ارتباط صمیمی، همدلانه و بدون تنش برقرار کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="اوقات فراغت افراد با الگوی IC"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای الگوی رفتاری  IC در اوقات فراغت نیز مانند محیط کاری، به‌دنبال ترکیبی از معنا، ساختار و نشاط هستند. آن‌ها نه کاملاً اهل ماجراجویی هستند، نه منزوی؛ نه فقط تفریح می‌خواهند، نه فقط مطالعه. بلکه به‌دنبال سرگرمی‌هایی هستند که هم به رشد ذهنی و هم به لذت عاطفی آن‌ها کمک کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. علایق ترکیبی: سرگرم‌کننده + یادگیرنده</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها از اوقاتی لذت می‌برند که در آن هم سرگرمی وجود دارد و هم چیزی یاد می‌گیرند.
          مطالعه کتاب‌های تخصصی با روایت جذاب، تماشای مستندها، حضور در گپ‌های دوستانه‌ـ‌تحلیلی یا کلاس‌های آموزشی کوتاه، برایشان نشاط‌آور است.
          مثال:
          دنبال‌کننده TED Talks  یا پادکست‌هایی مثل  چنل بی  هستند که هم روایت جذاب دارد و هم تحلیل‌مند است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. فعالیت‌های خلاقانه با نتیجه ملموس</h3>
        <p className="text-gray-800 leading-7">
          ICها دوست دارند کاری انجام دهند که خروجی داشته باشد.
          مثلاً نوشتن یک مطلب، طراحی گرافیکی، یا ضبط یک ویدئو آموزشی.
          آن‌ها از انجام کارهای فکری-خلاقانه لذت می‌برند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. طبیعت، اما با نظم و برنامه</h3>
        <p className="text-gray-800 leading-7">
          حضور در طبیعت برایشان لذت‌بخش است؛ ولی ترجیح می‌دهند برنامه‌ریزی‌شده و ساختارمند باشد.
          نه سفرهای بی‌برنامه و پرریسک، بلکه کوه‌پیمایی هدفمند، عکاسی در طبیعت، یا بازدید از اماکن فرهنگی و علمی.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تفریح با افراد باکیفیت</h3>
        <p className="text-gray-800 leading-7">
          از گشت‌وگذار با دوستانی لذت می‌برند که گفت‌وگوی عمیق، مودبانه و محترمانه دارند.
          محیط‌های پرهیاهو یا آدم‌های پرحرف ولی بی‌محتوا، آن‌ها را خسته می‌کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. فیلم و سریال مورد علاقه</h3>
        <p className="text-gray-800 leading-7">
          اغلب به فیلم‌ها و سریال‌های واقع‌گرایانه، درام تحلیلی، یا بیوگرافی‌های الهام‌بخش علاقه‌مندند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="اوقات فراغت افراد با الگوی IC"
      >
        <p className="text-gray-800 leading-7">
          پیشنهاد فیلم‌ها:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>A Beautiful Mind  – تلفیق ذهن تحلیلی و پیچیدگی روان</li>
          <li>The Social Network  – روایت عمیق از افراد تحلیل‌گر، دقیق و تاثیرگذار</li>
          <li>The Imitation Game  –  بازی تقلید، داستان آلن تورینگ، نابغه‌ای منطقی با رفتار اجتماعی کنترل‌شده</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. نوشتن، طراحی یا مطالعه در اوقات تنهایی</h3>
        <p className="text-gray-800 leading-7">
          از نوشتن یادداشت‌های شخصی، طراحی دقیق، برنامه‌ریزی هفتگی یا حتی یادگیری مهارتی جدید برای بهبود عملکرد شخصی لذت می‌برند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="تصمیم‌گیری در افراد با الگوی IC"
      >
        <p className="text-gray-800 leading-7">
          تیپ رفتاری  IC در تصمیم‌گیری‌ها، ترکیبی از دقت تحلیلی  C   و توجه به تأثیرگذاری و دیدگاه دیگران   I   را به کار می‌گیرد. این افراد به‌دنبال انتخابی هستند که هم منطقی باشد، هم تصویر خوبی از آن‌ها بسازد و هم باعث شود احساس کنند کار درستی انجام داده‌اند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. تصمیم‌گیری محتاطانه و تحلیل‌محور</h3>
        <p className="text-gray-800 leading-7">
          ICها به‌ندرت تصمیمات عجولانه می‌گیرند. آن‌ها به اطلاعات، تجربه و مشورت اتکا می‌کنند.
          پیش از تصمیم، سعی می‌کنند:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>داده‌ها را بررسی کنند،</li>
          <li>پیش‌بینی نتیجه را داشته باشند،</li>
          <li>و حتی تأثیر اجتماعی آن را نیز بسنجند.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. نگرانی از اشتباه یا برداشت بد دیگران</h3>
        <p className="text-gray-800 leading-7">
          آن‌ها از این می‌ترسند که تصمیم‌شان باعث سرزنش، برداشت نادرست یا خراب‌شدن تصویرشان شود.
          بنابراین ممکن است بین گزینه‌های مختلف، زیاد مکث کنند یا تصمیم را به تعویق بیندازند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. نیاز به بازخورد پیش از اقدام</h3>
        <p className="text-gray-800 leading-7">
          اگر بازخوردی مثبت یا تاییدی از اطرافیان دریافت کنند، تصمیم‌گیری‌شان سریع‌تر می‌شود.
          اما در صورت ابهام، وارد چرخه‌ای از تردید و بازنگری می‌شوند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تعارض بین تحلیل و احساسات</h3>
        <p className="text-gray-800 leading-7">
          گاهی در تصمیم‌گیری دچار کشمکش بین منطق و احساس می‌شوند:
          "این تصمیم از نظر منطقی درسته، ولی حس خوبی ندارم."
          یا "حس خوبی دارم، ولی اطلاعات کافی ندارم."
          این دوگانگی باعث کندی در حرکت آن‌ها می‌شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. راهکارهای بهبود تصمیم‌گیری در ICها</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>تعریف حد و زمان برای تحلیل: بررسی بیش از حد گاهی مانع اقدام می‌شود. مثال: تصمیم‌گیری در ۲۴ ساعت پس از جمع‌آوری داده‌ها.</li>
          <li>مشورت با تیپ‌های High D و CS: این افراد می‌توانند با قاطعیت خود به  IC کمک کنند که بین تحلیل و اقدام، تعادل برقرار کند.</li>
          <li>تمرین  ارزیابی سریع در موقعیت‌های کم‌ریسک  برای بالا بردن سرعت عمل.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="تصمیم‌گیری در افراد با الگوی IC"
      >
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          فرد  IC می‌خواهد بین دو فرصت شغلی انتخاب کند.
          او:   جدول مقایسه می‌کشد،
          با چند نفر مشورت می‌کند،
          به تأثیر احتمالی انتخابش بر دیگران فکر می‌کند،
          و اگر نگران اشتباه‌بودن تصمیم باشد، ممکن است ترجیح دهد "فعلاً تصمیم نگیرد!"
        </p>
        <p className="italic text-gray-700">
          جمله طلایی برای تصمیم‌گیری  ICها:
          تحلیل لازم است، اما تصمیم‌گیری، با اقدام کامل می‌شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد افراد با الگوی IC"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای الگوی  IC در بسیاری از موقعیت‌ها قابل اعتماد، دقیق، دوست‌داشتنی و اثرگذارند، اما برای رسیدن به حداکثر اثربخشی شخصی و حرفه‌ای، باید با شناخت محدودیت‌های رفتاری خود، اقدام به توسعه فردی کنند.
          در اینجا مجموعه‌ای از پیشنهادات کاملاً کاربردی و قابل‌اجرا برای بهبود عملکرد این تیپ رفتاری آورده شده است:
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. از تحلیل زیاد به اقدام برسید</h3>
        <p className="text-gray-800 leading-7">
          به جای تلاش برای "تصمیم درست صددرصدی"، سعی کنید تصمیم "به‌اندازه کافی خوب" را در زمان مناسب بگیرید.
          تحلیل طولانی، اغلب شما را از فرصت‌ها دور می‌کند.
          تمرین:
          در کارهای کم‌ریسک، با خودتان قرار بگذارید در کمتر از ۱۰ دقیقه تصمیم بگیرید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. جرأت ابراز احساسات و نیازها را افزایش دهید</h3>
        <p className="text-gray-800 leading-7">
          بسیاری از  ICها در بیان نظرات یا نیازهایشان ملاحظه‌کارند.
          یاد بگیرید که محترمانه، اما شفاف خواسته‌تان را بگویید.
          جمله تمرینی:
          برای من مهمه که این موضوع رو با دقت انجام بدیم، ولی نیاز دارم نظرتون رو بدونم.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. کمال‌گرایی را کنترل کنید</h3>
        <p className="text-gray-800 leading-7">
          شما می‌خواهید کارتان عالی باشد؛ اما عالی بودن همیشه به معنی بی‌نقص بودن نیست.
          تمرین کنید گاهی بگویید:  این خوبه، می‌رم سراغ قدم بعدی.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. نه گفتن را بیاموزید</h3>
        <p className="text-gray-800 leading-7">
          برای جلوگیری از خستگی عاطفی و ذهنی، گاهی باید  نه  بگویید.
          نه محترمانه، نشانه بلوغ و مرزبندی سالم است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. شفاف باشید و از نیت‌خوانی اجتناب کنید</h3>
        <p className="text-gray-800 leading-7">
          به‌جای حدس زدن واکنش دیگران، مستقیماً از آن‌ها سوال کنید.
          ارتباط صریح، ذهن شما را آرام می‌کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد افراد با الگوی IC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. اولویت‌بندی کنید</h3>
        <p className="text-gray-800 leading-7">
          گاهی می‌خواهید همه کارها را درست، دقیق، کامل انجام دهید.
          اما منابع محدودند. تمرین کنید:  کدام ۲۰ درصد کارها، ۸۰ درصد نتیجه را می‌دهند؟ اصل پارتو
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. روابط خود را متوازن‌تر کنید</h3>
        <p className="text-gray-800 leading-7">
          شما حمایت‌گر خوبی هستید. اما در برخی روابط، باید از دیگران نیز بخواهید که به شما توجه کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>8. از فرصت‌طلبی سالم نترسید</h3>
        <p className="text-gray-800 leading-7">
          شما از بی‌برنامه‌گی متنفر هستید. اما گاهی فرصت‌ها بدون مقدمه به سراغتان می‌آیند.
          تمرین کنید در لحظه "جرأت امتحان کردن" داشته باشید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>9. در جلسات و گروه‌ها، بیشتر مشارکت کنید</h3>
        <p className="text-gray-800 leading-7">
          منتظر کامل شدن فکر نمانید. مشارکت نیمه‌کامل، بهتر از سکوت مطلق است.
          صدای شما مفید است—بگذارید شنیده شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>10. نقش منتور را تجربه کنید</h3>
        <p className="text-gray-800 leading-7">
          به‌خاطر دقت، تسلط و نگاه حمایتی، شما منتور و مربی بسیار خوبی هستید.
          این نقش، هم به شما انگیزه می‌دهد، هم جایگاه‌تان را ارتقاء می‌بخشد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رمز موفقیت در تیپ IC"
      >
        <p className="text-gray-800 leading-7">
          افراد با تیپ رفتاری  IC، ترکیبی از انرژی، دقت، قدرت تأثیرگذاری و مسئولیت‌پذیری هستند. اما برای شکوفایی کامل این توانمندی‌ها، لازم است نقاط قوت‌شان را هوشمندانه استفاده کرده و با شناخت نقاط قابل‌بهبود، خود را به تعادل برسانند.
        </p>
        <p className="text-gray-800 leading-7">
          در اینجا، مهم‌ترین رموز موفقیت افراد  IC را به‌صورت شفاف، کاربردی و قابل اجرا ارائه می‌کنیم:
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. اقدام در کنار تحلیل</h3>
        <p className="text-gray-800 leading-7">
          موفقیت واقعی در عمل است، نه در ذهن. قدرت تحلیل خود را به "برنامه‌ی اجرا" تبدیل کنید، نه "برنامه‌ی تعویق". منتظر اطمینان کامل نباشید. همیشه بخشی از ابهام طبیعی است.
        </p>
        <p className="italic text-gray-700">
          شعار ذهنی:   تحلیل عالیه، اما اقدام موفقیت می‌سازه.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. اعتماد به قدرت ارتباط خود</h3>
        <p className="text-gray-800 leading-7">
          شما توان تأثیرگذاری مثبت از طریق کلام، استدلال و انرژی دارید.
          از این مهارت برای تأثیرگذاری سازنده در محیط‌های تیمی و اجتماعی بهره بگیرید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. استفاده از نظم برای خلق فرصت</h3>
        <p className="text-gray-800 leading-7">
          ساختار ذهنی منظم شما، بهترین ابزار برای دیدن فرصت‌ها در میان شلوغی‌هاست.
          مدیریت زمان، دسته‌بندی اطلاعات و سازمان‌دهی محتوا می‌تواند شما را یک سر و گردن بالاتر از بقیه نشان دهد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. مهارت  نه گفتن محترمانه  را تمرین کنید</h3>
        <p className="text-gray-800 leading-7">
          اگر همیشه در دسترس و موافق باشید، به‌تدریج از تأثیرتان کاسته می‌شود.
          قاطعیت مودبانه، اعتبار شما را افزایش می‌دهد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. به جای جلب رضایت، بر ارائه ارزش تمرکز کنید</h3>
        <p className="text-gray-800 leading-7">
          تمرکز بر جلب رضایت همه، شما را فرسوده می‌کند.
          در عوض، با تمرکز بر ایجاد  ارزش واقعی ، احترام و اعتماد ماندگار به‌دست می‌آورید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="رمز موفقیت در تیپ IC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. تقویت شهامت و تصمیم‌گیری سریع در موارد کم‌ریسک</h3>
        <p className="text-gray-800 leading-7">
          تصمیم‌گیری در موقعیت‌های روتین را سریع‌تر انجام دهید تا فضای ذهنی‌تان را برای تصمیم‌های بزرگ‌تر آزاد کنید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. بیان احساسات = کاهش فشار درونی</h3>
        <p className="text-gray-800 leading-7">
          وقتی احساساتتان را پنهان می‌کنید، درونی‌تر می‌شوید و این باعث کاهش تمرکز یا خستگی می‌شود.
          ارتباط با صداقت عاطفی، یکی از عوامل اصلی موفقیت بلندمدت برای شماست.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>8. تمرین ارائه و سخنرانی در جمع</h3>
        <p className="text-gray-800 leading-7">
          چون ترکیبی از  بیان  و  منطق  هستید، مهارت ارائه برای شما بسیار کلیدی است.
          یاد بگیرید چگونه پیام‌های پیچیده را به شکلی جذاب و قابل فهم انتقال دهید.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>9. کاهش وابستگی به تأیید دیگران</h3>
        <p className="text-gray-800 leading-7">
          موفقیت شخصی یعنی بدانید کی و چرا تصمیم گرفتید، حتی اگر همه با آن موافق نباشند.
          تأیید ارزشمند است، اما نداشتن آن نباید شما را متوقف کند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>10. حفظ رابطه‌ی مستمر با افراد نتیجه‌گرا و قاطع</h3>
        <p className="text-gray-800 leading-7">
          افراد High D، CS  یا DC  می‌توانند توازن خوبی برای شما ایجاد کنند.
          آن‌ها سرعت تصمیم‌گیری‌تان را بالا می‌برند و شما دقت و عمق را به آن‌ها می‌افزایید.
        </p>
        <p className="italic text-gray-700">
          جمله طلایی رمز موفقیت  ICها:
          وقتی کلام نافذت با تحلیل درست و اقدام به‌موقع همراه شود، هیچ مرزی برای موفقیتت وجود ندارد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ IC"
      >
        <p className="text-gray-800 leading-7">
          افراد  IC برای ارتقاء عملکرد و افزایش اثربخشی خود، نیازمند تعدیل برخی ویژگی‌ها و تقویت مهارت‌هایی در لایه‌های رفتاری دیگر هستند. این کار باعث تعادل بهتر و انعطاف‌پذیری بالاتر در موقعیت‌های مختلف می‌شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. تقویت لایه D   تسلط‌گری  در IC</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>قاطعیت بیشتر: افراد  IC معمولاً در تصمیم‌گیری‌ها و ابراز وجود کمی محتاط و تردیدآمیز هستند. تقویت قاطعیت به آن‌ها کمک می‌کند در مواجهه با شرایط پرچالش سریع‌تر و موثرتر عمل کنند.</li>
          <li>ریسک‌پذیری هدفمند: تمرین کنند در موارد کم‌ریسک، با اطمینان و جسارت بیشتری اقدام کنند.</li>
          <li>رهبری فعال‌تر: یاد بگیرند در گروه‌ها و پروژه‌ها نقش هدایت و تصمیم‌گیری را بیشتر بپذیرند.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تقویت لایه S   ثبات‌گرایی  در IC</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>صبوری و تحمل فشار: افزایش صبر و پایداری در برابر مشکلات و چالش‌ها</li>
          <li>همدلی بیشتر: تقویت مهارت‌های شنیدن فعال و درک احساسات دیگران</li>
          <li>ارتباطات تیمی: یاد بگیرند روابط صمیمی‌تر و پایدارتر با همکاران و اعضای تیم بسازند</li>
          <li>انعطاف‌پذیری رفتاری: کاهش مقاومت در برابر تغییرات منطقی و برنامه‌ریزی شده</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. تقویت لایه C  وظیفه‌شناسی  در IC</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>دقت و توجه به جزئیات: حفظ کیفیت و استاندارد بالا در کارها</li>
          <li>برنامه‌ریزی و سازماندهی: تقویت عادت‌های مرتب بودن و مدیریت زمان</li>
          <li>تحقیق و تحلیل: تمرکز بر جمع‌آوری داده‌ها و بررسی دقیق قبل از تصمیم‌گیری</li>
          <li>شفاف‌سازی انتظارات: یادگیری نحوه بیان دقیق اهداف و انتظارات در کارهای تیمی</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ IC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تعدیل لایه I  تاثیرگذاری  در IC</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>کاهش وابستگی به تایید دیگران: تمرین استقلال فکری و عمل</li>
          <li>تعادل در برقراری ارتباط: یادگیری زمان مناسب برای صحبت کردن و شنیدن</li>
          <li>پرهیز از تفریحات و گفتگوهای بی‌هدف: تمرکز روی گفت‌وگوهای معنی‌دار و هدفمند</li>
        </ul>
        <p className="text-gray-800 leading-7">
          جملات کلیدی برای تعدیل و تقویت:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>قاطع باش، اما انعطاف‌پذیر.</li>
          <li>صبور باش، اما با انگیزه.</li>
          <li>دقیق باش، اما گرفتار جزئیات نشو.</li>
          <li>تأثیرگذار باش، اما به خودت هم وفادار بمان.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی IC"
      >
        <p className="text-gray-800 leading-7">
          برای موفقیت و رشد حرفه‌ای، افراد  IC نیازمند توسعه مجموعه‌ای از مهارت‌ها و دانش‌های کلیدی هستند که به آن‌ها کمک می‌کند تا توانمندی‌های ذاتی خود را بهتر به کار بگیرند و چالش‌ها را با موفقیت پشت سر بگذارند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. مهارت‌های ارتباطی موثر</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>مهارت‌های شنیدن فعال و گفت‌وگوی سازنده، فن بیان و ارائه جذاب</li>
          <li>توانایی ایجاد ارتباط موثر با افراد مختلف در محیط کاری و اجتماعی</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. مدیریت زمان و برنامه‌ریزی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>توانایی اولویت‌بندی وظایف</li>
          <li>استفاده از ابزارهای مدیریت زمان و پروژه  مثلاً نرم‌افزارهای دیجیتال</li>
          <li>برنامه‌ریزی دقیق و انعطاف‌پذیر برای اجرای پروژه‌ها</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. تصمیم‌گیری و حل مسئله</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>تحلیل داده‌ها و اطلاعات به‌صورت ساختارمند، استفاده از روش‌های تصمیم‌گیری جمعی و فردی</li>
          <li>تمرین تصمیم‌گیری سریع و متوازن در شرایط نامطمئن</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. هوش هیجانی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>کنترل احساسات در موقعیت‌های استرس‌زا ، شناخت و مدیریت هیجانات خود و دیگران</li>
          <li>افزایش توانایی همدلی و تعامل مثبت</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی IC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. مهارت‌های فنی و تخصصی مرتبط با حوزه کاری</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>به‌روز بودن دانش تخصصی</li>
          <li>یادگیری مستمر مهارت‌های جدید و تکنولوژی‌های روز</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. خودمدیریتی و رشد فردی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>هدف‌گذاری و پیگیری مداوم اهداف</li>
          <li>تقویت اعتماد به نفس و استقلال فکری</li>
          <li>مدیریت استرس و فشارهای کاری</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. مهارت‌های همکاری و کار تیمی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>تقویت نقش حمایتی و مشارکتی</li>
          <li>مدیریت تعارض و ایجاد فضای مثبت تیمی</li>
          <li>افزایش انعطاف‌پذیری و احترام به نظرات دیگران</li>
        </ul>
        <p className="text-gray-800 leading-7">
          پیشنهاد کتاب:
          آیین دوست یابی  " How to Win Friends and Influence People" by Dale Carnegie
          کتابی کلاسیک درباره مهارت‌های ارتباطی و تأثیرگذاری بر دیگران.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی IC"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی  IC ترکیبی از تاثیرگذاری و دقت را دارند و بهترین عملکرد را در مشاغلی دارند که هم به مهارت‌های ارتباطی نیاز دارند و هم به تحلیل دقیق و مسئولیت‌پذیری. در این مشاغل، این افراد می‌توانند هم‌زمان تأثیرگذار، حرفه‌ای و قابل اعتماد باشند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. مدیر پروژه</h3>
        <p className="text-gray-800 leading-7">
          کنترل دقیق پروژه‌ها با ارتباط مستمر با تیم و ذینفعان
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. مشاور سازمانی</h3>
        <p className="text-gray-800 leading-7">
          تحلیل مسائل و ارائه راهکارهای قابل اجرا با مهارت‌های ارتباطی قوی
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. کارشناس بازاریابی</h3>
        <p className="text-gray-800 leading-7">
          برنامه‌ریزی و اجرای کمپین‌های هدفمند با توجه به جزئیات بازار
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تحلیلگر داده</h3>
        <p className="text-gray-800 leading-7">
          بررسی و تحلیل داده‌های پیچیده و ارائه گزارش‌های دقیق
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. متخصص آموزش و توسعه</h3>
        <p className="text-gray-800 leading-7">
          طراحی و اجرای دوره‌های آموزشی به شکل ساختارمند و جذاب
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی IC"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. مدیر روابط عمومی</h3>
        <p className="text-gray-800 leading-7">
          برقراری ارتباط موثر و مدیریت تصویر سازمان در رسانه‌ها
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. وکیل یا مشاور حقوقی</h3>
        <p className="text-gray-800 leading-7">
          دقت و تحلیل حقوقی همراه با قدرت بیان قوی
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>8. مدیر کنترل کیفیت</h3>
        <p className="text-gray-800 leading-7">
          حفظ استانداردهای دقیق و بررسی مستمر فرآیندها
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>9. مدیر منابع انسانی</h3>
        <p className="text-gray-800 leading-7">
          مدیریت روابط انسانی با تکیه بر تحلیل نیازها و توانمندسازی کارکنان
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>10. نویسنده فنی یا روزنامه‌نگار</h3>
        <p className="text-gray-800 leading-7">
          تولید محتوای دقیق، مستند و قابل فهم
        </p>
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          یک مدیر پروژه  IC، جلسات را با انرژی و انگیزه شروع می‌کند، سپس با دقت بالا مسائل فنی پروژه را بررسی کرده و تصمیمات مستند و قاطعی اتخاذ می‌کند که باعث پیشرفت و موفقیت پروژه می‌شود.
        </p>
        <p className="text-gray-800 leading-7">
          نکته مهم:
          افراد  IC معمولاً در محیط‌های سازمان‌یافته، با استانداردهای مشخص و فرصت‌های ارتباطی سازنده، بهترین عملکرد را دارند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="همسر مناسب و نحوه ارتباط مؤثر با او"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری  IC شخصیتی ترکیبی از تأثیرگذاری اجتماعی و دقت تحلیلی دارند. در زندگی زناشویی، همسر آن‌ها نیازمند درک دقیق این ویژگی‌ها و ایجاد فضایی است که هم نیاز به حمایت عاطفی و هم احترام به ساختار و نظم در رابطه تامین شود.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>ویژگی‌های شخصیتی مناسب همسر فرد IC</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>صبور و فهمیده: چون  ICها ممکن است در تصمیم‌گیری‌ها دچار تأخیر و تردید شوند، همسری با صبر و درک بالا کمک بزرگی است.</li>
          <li>قابل اعتماد و مسئولیت‌پذیر: همسری که بتواند به آن‌ها اعتماد کند و به وعده‌ها و وظایفش پایبند باشد.</li>
          <li>توانمند در ارتباطات: کسی که بتواند با آن‌ها به صورت مؤثر و منطقی گفت‌وگو کند و به بیان احساسات کمک کند.</li>
          <li>متعادل بین احساس و منطق: همسری که هم احساسات را درک کند و هم دیدگاه منطقی داشته باشد.</li>
          <li>حمایتگر، اما نه کنترل‌کننده: فضای لازم برای استقلال و تحلیلگری فرد  IC را فراهم کند بدون اینکه کنترل‌گر باشد.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که همسر فرد IC باید بداند:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  IC به دقت و نظم اهمیت زیادی می‌دهند و دوست دارند محیط زندگی‌شان منظم و پیش‌بینی‌پذیر باشد.</li>
          <li>آن‌ها در روابط اجتماعی و عاطفی گرم و تأثیرگذار هستند، اما ممکن است در بروز احساسات خود محتاط باشند.</li>
          <li>گاهی در تصمیم‌گیری‌ها تردید دارند و به حمایت و تشویق همسر نیازمندند.</li>
          <li>نیاز دارند همسرشان به آنها زمان دهد تا به صورت منطقی و دقیق مسائل را بررسی کنند.</li>
          <li>ترجیح می‌دهند بحث‌ها و اختلافات به صورت منطقی و بدون هیجان زیاد حل شود.</li>
          <li>دوست دارند تحسین و قدردانی را در رابطه ببینند، نه انتقاد بی‌موقع یا عجولانه.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که فرد باید در زندگی زناشویی رعایت کند:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>تلاش کند در بیان احساسات و نیازهای خود شفاف و صادق باشد.</li>
          <li>یاد بگیرد گاهی به سرعت تصمیم‌گیری کند و از تأخیر در حل مسائل جلوگیری کند.</li>
          <li>به همسر خود اجازه دهد احساساتش را بیان کند و با احترام به نظرات او گوش دهد.</li>
          <li>به جای تمرکز صرف بر جزئیات، گاهی به تصویر کلی و احساسات کلی رابطه توجه کند.</li>
          <li>در شرایط پرتنش، با حفظ آرامش و منطق رفتار کند و از واکنش‌های احساسی شدید پرهیز کند.</li>
          <li>برای ایجاد فضای صمیمیت، زمان‌های غیررسمی و تفریحی با همسرش بگذارند.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که فرد باید در زندگی زناشویی رعایت کند:"
      >
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          فرض کنید زوجی در حال برنامه‌ریزی برای یک سفر هستند. فرد  IC می‌خواهد همه جزئیات برنامه مثل مسیر، اقامتگاه و زمان‌بندی را دقیق بررسی کند، اما همسرش ممکن است بخواهد سریع‌تر تصمیم بگیرند و بیشتر به لذت سفر فکر کند. در این شرایط:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>همسر فرد  IC با صبر و آرامش، فرصت می‌دهد تا برنامه‌ریز دقیق کارش را انجام دهد.</li>
          <li>فرد  IC تلاش می‌کند به جای وسواس زیاد، روی کلیات تمرکز کند و به احساس همسرش هم احترام بگذارد.</li>
          <li>هر دو در نهایت با توافقی منطقی و احساسی سفر را برنامه‌ریزی می‌کنند که باعث رضایت و آرامش هر دو می‌شود.</li>
        </ul>
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی برای درک بهتر ارتباط زوجین  IC :
          "Silver Linings Playbook"  2012
          دفترچه امید بخش
          این فیلم نشان می‌دهد چگونه دو شخصیت با تفاوت‌های رفتاری می‌توانند با درک و تعامل مناسب، رابطه‌ای سالم و موفق بسازند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر والدین IC با فرزندان و بالعکس"
      >
        <p className="text-gray-800 leading-7">
          والدین با الگوی رفتاری  IC به دلیل ترکیب مهارت‌های ارتباطی قوی و دقت بالا، می‌توانند روابطی سالم، حمایتی و الهام‌بخش با فرزندان خود برقرار کنند. اما برای موفقیت بیشتر در این رابطه، نیازمند درک متقابل و رعایت نکاتی کلیدی هستند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>ارتباط والدین IC با فرزندان:</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>شنونده فعال و حامی: والدین  IC به دقت به حرف‌های فرزندان گوش می‌دهند و سعی می‌کنند احساسات و نیازهای آن‌ها را درک کنند.</li>
          <li>برنامه‌ریز و منظم: تمایل دارند فرزندان در چارچوب قوانین و برنامه‌های منظم رشد کنند، این باعث ایجاد محیط امن و قابل پیش‌بینی می‌شود.</li>
          <li>ترغیب به تفکر مستقل: والدین  IC کودکان را به تحلیل و تفکر منطقی تشویق می‌کنند، به آن‌ها کمک می‌کنند تصمیمات آگاهانه بگیرند.</li>
          <li>توجه به جزئیات در تربیت: به مسائل کوچک و رفتارهای روزمره فرزندان توجه می‌کنند و تلاش می‌کنند به صورت مستمر رشد و پیشرفت آن‌ها را ارزیابی کنند.</li>
          <li>توجه به ابراز احساسات: والدین  IC ممکن است در بروز احساسات محتاط باشند؛ بنابراین باید تلاش کنند محیطی امن برای ابراز عواطف فرزندان فراهم کنند.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط فرزندان با والدین IC:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>احترام به قوانین و ساختار: فرزندان باید به چارچوب‌ها و قواعدی که والدین وضع می‌کنند احترام بگذارند، چرا که این والدین از نظم و ثبات حمایت می‌کنند.</li>
          <li>ابراز شفاف احساسات: فرزندان باید یاد بگیرند احساسات خود را به روشنی و با احترام بیان کنند تا والدین بتوانند بهتر آن‌ها را درک کنند.</li>
          <li>صبر و درک: در مواقعی که والدین به جزئیات می‌پردازند یا تصمیمات را با دقت بررسی می‌کنند، فرزندان باید صبور باشند و اجازه دهند این فرآیند به خوبی طی شود.</li>
          <li>پذیرش بازخورد: باید به بازخوردهای والدین به عنوان فرصتی برای رشد نگاه کنند، حتی اگر سخت‌گیرانه باشد.</li>
        </ul>
        <p className="text-gray-800 leading-7">
          نکته مهم: ارتباط والدین و فرزندان با الگوی  IC نیازمند تعادل میان آزادی و ساختار، محبت و نظم، و بیان احساس و منطق است تا رابطه‌ای مثبت و موثر شکل گیرد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط فرزندان با والدین IC:"
      >
        <p className="text-gray-800 leading-7">
          مثال کاربردی: فرض کنید فرزند نوجوان می‌خواهد ساعت بیشتری از شب را در شبکه‌های اجتماعی بگذراند. والد  IC :  ابتدا با دقت به دلایل فرزند گوش می‌دهد،
          سپس با توضیح منطقی درباره اهمیت خواب کافی و تاثیر آن بر سلامت و عملکرد تحصیلی،
          و در نهایت با تعیین قوانین روشن و قابل پیگیری، موضوع را مدیریت می‌کند.
          فرزند هم باید با احترام و شفافیت درباره نیازها و احساسات خود صحبت کند.
        </p>
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی برای درک بهتر ارتباط والدین و فرزندان:
          "Little Miss Sunshine"  2006
          میس سان‌شاین کوچولو
          فیلمی درباره حمایت خانواده، ارتباطات پیچیده عاطفی و رشد فردی که می‌تواند الهام‌بخش والدین  IC باشد.
        </p>
      </Page>
    </>
  )
}

export default IC
